/* eslint-disable */
import { Stack, Typography, Box, useTheme } from '@mui/material';
import { HomeKeyLevels } from 'components/home/HomeKeyLevels';
import dayjs from 'dayjs';
import { nextBusinessDay } from 'util/shared';
import { useEffect, useState } from 'react';
import useHomeContent from 'hooks/home/useHomeContent';
import { Loader } from 'components';
import { Center } from 'components/shared/Center';

const IndexLevels = () => {
  const theme = useTheme();
  const [keyLevelsData, setKeyLevelsData] = useState<any>();
  const [errored, setErrored] = useState(false);
  const [loading, setLoading] = useState(false);

  const { getKeyLevelsData } = useHomeContent();

  const fetchData = async () => {
    try {
      setLoading(true);
      const rawKeyLevelsData = await getKeyLevelsData();

      setKeyLevelsData(rawKeyLevelsData?.data);
    } catch (err) {
      setErrored(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Loader isLoading={loading}>
      {errored ? (
        <Center
          sx={{
            cursor: 'pointer',
          }}
        >
          <Typography onClick={fetchData} sx={{ fontSize: '14px' }}>
            Unfortunately, there was an error. Click here to try again.
          </Typography>
        </Center>
      ) : (
        <Box
          sx={{
            width: '100%',
            flex: 1,
            overflow: 'auto',
          }}
        >
          <HomeKeyLevels data={keyLevelsData} />
        </Box>
      )}
    </Loader>
  );
};

export default IndexLevels;
